import { Grid, Paper } from '@mui/material'
import { styled } from '@mui/material/styles'

interface GridTypes {
    children?: any
    columns?: number | object
    columnSpacing?: any
    container?: boolean
    item?: boolean
    direction?:
        | 'column-reverse'
        | 'column'
        | 'row-reverse'
        | 'row'
        | Array<'column-reverse' | 'column' | 'row-reverse' | 'row'>
        | object
    offset?: number
    rowSpacing?: Array<number | string> | number | object | string
    size?: number | object | 'grow'
    spacing?: Array<number | string> | number | object | string
    wrap?: 'nowrap' | 'wrap-reverse' | 'wrap'
    ref?: any
    sx?: object
    style?: object
    hidden?: boolean
    role?: string
    xs?: number | 'auto' | boolean
    sm?: number | 'auto' | boolean
    md?: number | 'auto' | boolean
    lg?: number | 'auto' | boolean
    xl?: number | 'auto' | boolean
    alignItems?: string
    id?: any
    key?: any
    onClick?: () => void
    className?: string
}

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: (theme.vars ?? theme).palette.text.secondary,
    ...theme.applyStyles('dark', {
        backgroundColor: '#1A2027',
    }),
}))

const UniversalGrid = ({
    children,
    columns = 12,
    columnSpacing = null,
    container = false,
    item = false,
    direction = 'row',
    offset,
    rowSpacing,
    size = { xs: 12, md: 12, lg: 12 },
    xs,
    sm,
    md,
    lg,
    xl,
    spacing = 0,
    wrap = 'wrap',
    ref,
    sx = {},
    style = {},
    hidden,
    role,
    alignItems,
    id,
    key,
    onClick = () => {},
    className,
}: GridTypes) => {
    // Build the MUI v7 `size` prop from whichever breakpoints were passed
    // (xs/sm/md/lg/xl), falling back to the default when none are provided.
    const breakpointSize: Record<string, any> = {}
    if (xs !== undefined) breakpointSize.xs = xs
    if (sm !== undefined) breakpointSize.sm = sm
    if (md !== undefined) breakpointSize.md = md
    if (lg !== undefined) breakpointSize.lg = lg
    if (xl !== undefined) breakpointSize.xl = xl
    const resolvedSize =
        Object.keys(breakpointSize).length > 0 ? breakpointSize : size

    if (container) {
        return (
            <Grid
                container
                columns={columns}
                columnSpacing={columnSpacing}
                direction={direction}
                rowSpacing={rowSpacing}
                wrap={wrap}
                role={role}
                hidden={hidden}
                sx={sx}
                style={style}
                ref={ref}
                spacing={spacing}
                alignItems={alignItems}
                id={id}
                onClick={onClick}
                className={className}
                offset={offset}
                key={key}
            >
                {children}
            </Grid>
        )
    } else if (item) {
        return (
            <Grid
                size={resolvedSize}
                sx={sx}
                style={style}
                hidden={hidden}
                ref={ref}
                role={role}
                id={id}
                className={className}
                onClick={onClick}
                offset={offset}
                key={key}
            >
                {children}
            </Grid>
        )
    } else {
        return (
            <Grid
                size={resolvedSize}
                sx={sx}
                style={style}
                hidden={hidden}
                ref={ref}
                role={role}
                id={id}
                className={className}
                onClick={onClick}
                offset={offset}
                key={key}
            >
                {children}
            </Grid>
        )
    }
}

export default UniversalGrid
